
import { MenuItem } from './MenuInterfaces';
const menu: MenuItem[] = [
  // {
  //   text: "Dashboard",
  //   link: "/dashboard",
  // },
  {
    text: "Party Master",
    link: "/party-list",
    // subMenu: [
    //   {
    //     text: "Buyer",
    //     link: "/buyer-onboarding",
    //   },
    //   {
    //     text: "Supplier",
    //     link: "/supplier-onboarding",
    //   },
      
    // ],
  },
  {
    text: "Masters",
    subMenu: [
      {
        text: "Material Categories",
        link: "/material-categories",
      },
      {
        text: "Material Library",
        link: "/material-library",
      },
      {
        text: "UOM Master",
        link: "/uom-master",
      },
      // {
      //   text: "Document Types",
      //   link: "/document-types",
      // },
    ],
  },
  {
    text: "Enquiries",
    link: "/enquiries",
  },
  {
    text: "Settings",
    subMenu: [
      {
        text: "Applications",
        link: "/sa-applications",
      },
      {
        text: "SaaS Pricing",
        link: "/sa-pricing",
      },
      {
        text: "Enterprise Pricing",
        link: "/sa-bundles",
      },
      {
        text: "Coupons",
        link: "/sa-coupons",
      },
      {
        text: "Taxes",
        link: "/sa-taxes",
      },
      {
        text: "Invoices",
        link: "/sa-invoices",
      },
      {
        text: "Receivables",
        link: "/sa-receivables",
      },
      // Customers managed via Party Master
      // {
      //   text: "Customers",
      //   link: "/sa-customers",
      // },
    ],
  },
];
export default menu;
